








































































import { Vue, Component } from 'vue-property-decorator'
import validation from '@/common/element-val'
import { ElForm } from 'element-ui/types/form'
import { MessageText } from '@/services/data'
import Msg from '@/components/Msg.vue'
import utility from '@/common/utility'
import userApiService, { UserApiModel } from '@/services/userApiService'

@Component({
  computed: {
    utility () {
      return utility
    }
  },
  components: {
    Msg
  }
})
export default class Mail extends Vue {
  $refs: {
    accForm: ElForm;
  }

  accounts = {
    ApiAccounts: [
      {
        AccountName: null as string,
        Key: null as string,
        Secret: null as string,
        CheckingIdleFunds: null as boolean
      }
    ] as UserApiModel[]
  }

  rules = {
    AccountName: validation.requiredRule(),
    Key: validation.requiredRule(),
    Secret: validation.requiredRule()
  }

  message: MessageText = null
  async mounted () {
    await this.load()
  }

  async load () {
    const res = await userApiService.listByName('BinanceAccounts')
    this.accounts = { ApiAccounts: res.Result ?? [] }
  }

  async submit () {
    if (this.accounts.ApiAccounts.length > 0 && this.accounts.ApiAccounts.every(p => p.Key?.trim() && p.Secret?.trim())) {
      const res = await userApiService.addOrUpdate('BinanceAccounts', this.accounts.ApiAccounts)
      if (res.Result) {
        this.message = { success: this.$t('msg.settingSaved') as string }
        await this.load()
      } else {
        this.message = { error: this.$t('msg.unableToSave') as string }
      }
    } else {
      this.message = { error: this.$t('val.required') as string }
    }
  }
}
